module.exports = __webpack_public_path__ + "static/img/Bachelor_010713.5d0a2b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010713.jpg
// module id = 229
// module chunks = 0